<form [formGroup]="form" class="ml-form" fxLayout="column" [fxLayoutGap]="V_LYT_GAP">
  <div class="flex-wrap">
    <mat-form-field fxFlex>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_IEC_GEMEINSAME_ASDU_ADRESSE"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Gemeinsame ASDU-Adresse</mat-label>
      <input matInput
        formControlName="gemeinsameASDUAdresse"
        [redispatchDisableControl]="readonly || disabled"
        type="number"
        name="funkrundsteuerEmpfaengerInformationen_gemeinsameASDUAdresse">
      @if (f.gemeinsameASDUAdresse.hasError('required')) {
        <mat-error>
          Bitte geben Sie einen Wert an
        </mat-error>
      }
      @if (f.gemeinsameASDUAdresse.hasError('min') || f.gemeinsameASDUAdresse.hasError('max')) {
        <mat-error>
          Dieser Wert muss zwischen 1 und 65534 liegen
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field fxFlex="25">
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_IEC_ABREGELUNGSTYP"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Abregelungstyp</mat-label>
      <mat-select
        [required]="true"
        [(ngModel)]="abregelungstyp"
        [ngModelOptions]="{ standalone: true }"
        [redispatchDisableControl]="readonly || disabled"
        (selectionChange)="f.gemeinsameASDUAdresse.markAsDirty()">
        @for (typ of abregelungstypSelectionList; track typ.key) {
          <mat-option [value]="typ.key">{{ typ.description }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="div-table" formArrayName="adressen" fxLayout="column">

    <div class="header" fxLayout="row" fxFlex [fxLayoutGap]="LYT_GAP">
      <div [fxFlex]="COLS[0]">
        <span class="icon-text-combo">ADRESSIERUNG
          @if (getHilfetext(Feld.TABLEHEADER_IEC_ADRESSIERUNG) | async; as text) {
            <mat-icon
              svgIcon="innogy_picto_speech-bubble_exclamationmark"
              aria-hidden="false"
              [attr.aria-label]="text"
              [matTooltip]="text"
              matTooltipPosition="right"
              matTooltipClass="multiline-tooltip"
            >
            </mat-icon>
          }
        </span>
      </div>
      <div [fxFlex]="COLS[1]">
        <span class="icon-text-combo bold">HOHES BYTE
          @if (getHilfetext(Feld.TABLEHEADER_IEC_HOHES_BYTE) | async; as text) {
            <mat-icon
              svgIcon="innogy_picto_speech-bubble_exclamationmark"
              aria-hidden="false"
              [attr.aria-label]="text"
              [matTooltip]="text"
              matTooltipPosition="right"
              matTooltipClass="multiline-tooltip"
            >
            </mat-icon>
          }
        </span>
      </div>
      <div [fxFlex]="COLS[2]">
        <span class="icon-text-combo bold">MITTLERES BYTE
          @if (getHilfetext(Feld.TABLEHEADER_IEC_MITTLERES_BYTE) | async; as text) {
            <mat-icon
              svgIcon="innogy_picto_speech-bubble_exclamationmark"
              aria-hidden="false"
              [attr.aria-label]="text"
              [matTooltip]="text"
              matTooltipPosition="right"
              matTooltipClass="multiline-tooltip"
            >
            </mat-icon>
          }
        </span>
      </div>
      <div [fxFlex]="COLS[3]">
        <span class="icon-text-combo bold">NIEDRIGES BYTE
          @if (getHilfetext(Feld.TABLEHEADER_IEC_NIEDRIGES_BYTE) | async; as text) {
            <mat-icon
              svgIcon="innogy_picto_speech-bubble_exclamationmark"
              aria-hidden="false"
              [attr.aria-label]="text"
              [matTooltip]="text"
              matTooltipPosition="right"
              matTooltipClass="multiline-tooltip"
            >
            </mat-icon>
          }
        </span>
      </div>
      <div [fxFlex]="COLS[4]">
        <span class="icon-text-combo bold">TYPKENNUNG
          @if (getHilfetext(Feld.TABLEHEADER_IEC_TYPKENNUNG) | async; as text) {
            <mat-icon
              svgIcon="innogy_picto_speech-bubble_exclamationmark"
              aria-hidden="false"
              [attr.aria-label]="text"
              [matTooltip]="text"
              matTooltipPosition="right"
              matTooltipClass="multiline-tooltip"
            >
            </mat-icon>
          }
        </span>
      </div>
      <div [fxFlex]="COLS[5]"></div>
    </div>

    @for (fAdresse of fAdressen; track fAdresse; let isLast = $last) {
      <div
        [class.hidden]="isHidden(fAdresse.value.kopplungsTyp)" fxLayout="column" fxFlex data-qa="iec101104-adresse">
        <redispatch-abregelinformationen-iec101104-adresse [form]="fAdresse"
          [disabled]="disabled || isHidden(fAdresse.value.kopplungsTyp)"
          [readonly]="readonly">
        </redispatch-abregelinformationen-iec101104-adresse>
        @if (!isLast) {
          <hr>
        }
      </div>
    }
  </div>
</form>
